<template>
  <button
    class="direction-button"
    :class="{ 'spin-animation': isSpinning }"
    :aria-label="$t('travelPlanner.search.switchDirection')"
    @click="switchStations">
    <svg class="direction-button__icon">
      <use :xlink:href="`#${roundTrip}`" />
    </svg>
  </button>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import { useTravelSearchStore } from '@/stores/travelSearchStore'
  import { pushInteractionToDatalayer } from '@/services/gaLoggingService'
  import roundTrip from '@/assets/icons/roundTrip.svg'

  defineOptions({
    name: 'DirectionButton',
  })

  const travelSearchStore = useTravelSearchStore()
  const isSpinning = ref(false)

  const switchStations = () => {
    if (travelSearchStore.OriginStation.name && travelSearchStore.destinationStation.name) {
      const tempStation = { ...travelSearchStore.OriginStation }
      travelSearchStore.setOriginStation(travelSearchStore.destinationStation)
      travelSearchStore.setDestinationStation(tempStation)

      pushInteractionToDatalayer('switch direction', { selection: '' })
      isSpinning.value = true
      setTimeout(() => {
        isSpinning.value = false
      }, 300)
    }
  }
</script>

<style lang="scss" scoped>
  .direction-button {
    background-color: $clr-primary;
    border: none;
    border-radius: 50%;
    color: $clr-white;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    top: 35%;
    right: 12px;
    transform: translateX(5%) rotate(90deg);
    z-index: 1;

    &:hover,
    &:focus {
      background-color: $clr-primary-400;
    }

    @media (min-width: $breakpoint-xl) {
      top: 20%;
      left: 50%;
      width: 32px;
      height: 32px;
      transform: translateX(-50%) rotate(0deg);
    }

    &__icon {
      width: 26px;
      height: 26px;
      fill: white;

      @media (min-width: $breakpoint-xl) {
        width: 20px;
        height: 20px;
      }
    }

    &.spin-animation &__icon {
      animation: spin 0.5s ease-out;
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(190deg);
    }
  }
</style>
